/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getPayTypeByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetPayTypeById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getPayTypeByIdIdRegExpTwo)]).optional()
});

export type GetPayTypeById = zod.input<typeof GetPayTypeById>;
export type GetPayTypeByIdOutput = zod.output<typeof GetPayTypeById>;
